<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Room Air Quality</h2>

      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a>Application</a>
        </li>
        <li class="breadcrumb-item">
          <a>Air Quality</a>
        </li>
        <li class="breadcrumb-item">
          <a>Home</a>
        </li>
      </ol>
    </div>    
    <div class="col-md-2">
      <div class="admin-customer-select " *ngIf="azureAuthService.isAdmin()">
        <select *ngIf="app.customers && app.customers.length > 0" [(ngModel)]="app.customerId" class="form-control" (change)="changeCustomer()">
          <option *ngFor="let c of app.customers" value="{{c.customerId}}">{{ c.customerName }}</option>
        </select>
      </div>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">

    </div>
  </div>